import { render } from "./title.vue?vue&type=template&id=427b8a42&scoped=true"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"

import "./title.vue?vue&type=style&index=0&id=427b8a42&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427b8a42"]])

export default __exports__